<template>
  <!-- m201 >>> 导入 >>> 选择要上传的Excel表 -->
  <vea-dialog
    ref="queryDialog"
    append-to-body
    class="create_dialog"
    :title="'选择模式'"
    :show="showDialog"
    :before-close="beforeShut"
  >
    <div slot="title" class="dialog_title">
      <svg-icon icon-class="warn" />
      {{'拖拽文件到这里'}}
    </div>

    <div class="dialog_content">
      <el-radio-group v-model="sheet">
        <el-radio v-for="item in list" :key="item + new Date()" :label="item" :style="w">{{ item }}</el-radio>
      </el-radio-group>
    </div>
    <!-- 底部 -->
    <div slot="footer-right" class="dialog_btn">
      <el-button plain v-preventReClick @click="hideDialog('cancel')">取消</el-button>
      <el-button
        type="primary"
        :disabled="!sheet"
        v-preventReClick
        @click="hideDialog('confirm')"
      >确认</el-button>
    </div>
  </vea-dialog>
</template>
<script>
export default {
  props: {
    show: Boolean,
    content: {
      // 提示内容
      type: String,
      default: ''
    },
    beforeClose: {
      type: Function,
      default: (action, done) => done()
    },
    list: {
      // excel表名
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showDialog: false,
      sheet: null
    }
  },
  computed: {
    w() {
      // 计算宽度
      let maxLen = 0
      this.list.forEach(item => {
        const len = this.getLength(item)
        if (len > maxLen) maxLen = len
      })
      let res = '100%'
      if (maxLen <= 34) {
        res = 'width: 50%'
      }
      if (maxLen <= 20) {
        res = 'width: 33.333%'
      }
      if (maxLen <= 14) {
        res = 'width: 25%'
      }
      // console.log(123, { res, maxLen })
      return res
    }
  },
  watch: {
    show: {
      handler(n) {
        this.showDialog = n
        // this.sheet = null ???
      },
      immediate: true
    }
  },
  methods: {
    // 计算字符串的字节长度
    getLength(str) {
      var bytesCount = 0
      for (var i = 0, n = str.length; i < n; i++) {
        var c = str.charCodeAt(i)
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          bytesCount += 1
        } else {
          bytesCount += 2
        }
      }
      return bytesCount
    },
    close() {
      this.showDialog = false
    },
    // 隐藏报表参数弹窗
    hideDialog(action) {
      if (this.beforeClose.name.indexOf('default') > -1) {
        // name：开发环境 _default 生产环境 default
        this.close()
      } else {
        // @todo 添加loading效果等待父组件: done(true/false)
        this.beforeClose(action, this.close)
      }
    },
    // 弹窗关闭前回调方法
    beforeShut(action, done) {
      this.beforeClose(action, done)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
// 内部弹窗：输入报表参数
.create_dialog {
  /deep/.el-dialog {
    width: 600px;
    min-height: 280px;
    .el-dialog__header {
      .reports_title_box {
        .reports_title {
          .dialog_title {
            @include flexCenter;
            svg {
              @include wh(20px, 20px);
              color: #fff;
              margin-right: 6px;
            }
          }
        }
      }
    }
    .el-dialog__body {
      padding: 20px;
      padding-bottom: 0;
      @include flexCenter;
      .dialog_content {
        width: 100%;
        height: 100%;
        svg {
          @include wh(38px, 38px);
          color: rgb(250, 173, 20);
          margin-right: 8px;
        }
        .el-radio-group {
          max-height: 100%;
          overflow: auto;
          display: flex;
          flex-wrap: wrap;
          .el-radio {
            width: 50%;
            margin: 0;
            padding: 5px 10px 10px 0;
            display: flex;
            align-items: center;
            .el-radio__label {
              // font-size: 16px;
            }
          }
        }
      }
    }
    .el-dialog__footer {
      .dialog_btn {
      }
    }
  }
}
</style>
